







































import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({
  name: 'TableMenu',
  data() {
    return {
      titleUserActive: 'Salesman Bulletin Visited',
      alignCard: 'center',
      fieldsUserActive: [
        { key: 'no' },
        { key: 'file_code' },
        { key: 'title' },
        { key: 'created_date' },
        { key: 'total_user' },
        { key: 'total_visit' },
      ],
    }
  },
})
export default class extends Vue {
  @Prop({}) public dataTable
}
